import { render, staticRenderFns } from "./InstrumentOrder.vue?vue&type=template&id=c4e0c912&scoped=true"
import script from "./InstrumentOrder.vue?vue&type=script&lang=ts"
export * from "./InstrumentOrder.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentOrder.vue?vue&type=style&index=0&id=c4e0c912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e0c912",
  null
  
)

export default component.exports